import React, { Fragment } from 'react';
import { withRouteData, Head } from 'react-static';

import NewMenu from '../../../blocks/Menu/NewMenuv2';
import NewFooter from '../../../blocks/NewFooter/NewFooterV2';
import Picture from '../../../components/Picture';
import DemoForm from '../../../components/site/Forms/DemoForm';
import PromoBannerCTA from '../../../blocks/CardFooter/PromoBannerCTA';
import TwoColumnAccordionWithImage from '../../../components/site/custom/TwoColumnAccordionWithImage';
import GenericFAQ from '../../../components/site/custom/GenericFAQ';
import TestimonialVideoCards from '../../../components/site/TestimonialCardStars/TestimonialVideoCards';
import HeroRatings from '../../../components/site/HeroRatings/HeroRatings';
import TrustedByCompanies from '../../../components/site/custom/TrustedByCompanies';

import './SistemaDePedidosComIA.scss';

const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "O recurso está disponível para todos os planos?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Sim! É possível realizar 5 usos por mês/por usuário sem custos nos planos Bronze e Prata (indústrias e distribuidoras) e Básico e Intermediário (representantes). O recurso é ilimitado nos planos Ouro (indústrias e distribuidoras) e Corporativo (representantes)."
      }
    },
    {
      "@type": "Question",
      "name": "O recurso é gratuito?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Sim, o recurso é gratuito para qualquer plano contratado no Mercos, com limite de 5 usos por mês/usuário nos planos Bronze, Prata, Básico e Intermediário. O recurso é ilimitado nos planos Ouro e Corporativo. Basta acessar a aba de Pedidos, clicar em “Criar pedido / orçamento” e começar a aproveitar a agilidade e eficiência dos Pedidos com IA."
      }
    },
    {
      "@type": "Question",
      "name": "O recurso atende somente mensagens recebidas por WhatsApp ou outras ferramentas de comunicação?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "O Pedidos com IA funciona com qualquer tipo de conteúdo enviado pelo cliente, seja ele vindo do WhatsApp, e-mail, Telegram, mensagem de voz ou até anotações feitas manualmente. Você só precisa copiar a mensagem ou enviar o arquivo no sistema Mercos — a IA interpreta e transforma tudo isso em um pedido para revisar e finalizar."
      }
    },
    {
      "@type": "Question",
      "name": "Posso usar o sistema de pedidos com IA em qualquer dispositivo?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "O Sistema de Pedidos com IA funciona em dispositivos com acesso ao sistema online da Mercos. A funcionalidade “Ditar texto” requer permissão de microfone e funciona nos navegadores Chrome, Edge e Safari, mas não é suportada em Firefox e Opera."
      }
    },
    {
      "@type": "Question",
      "name": "O recurso é integrado ao Mercos?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Sim, tanto ao sistema de vendas quanto ao e-commerce B2B. A geração é automática dentro do sistema de vendas e, no e-commerce B2B, os pedidos viram carrinhos prontos para finalização pelos clientes, facilitando e agilizando toda a operação."
      }
    }
  ]
};

const newFaqItems = faqJsonLd.mainEntity.map(item => ({
  question: item.name,
  answer: (
    <Fragment>
      <p>{item.acceptedAnswer.text}</p>
    </Fragment>
  )
}));

const imageJsonLd = {
  "@context": "https://schema.org",
  "@type": "ImageObject",
  "contentUrl": "https://mercos.com/images/sistema-de-pedidos-com-ia.jpg",
  "url": "https://mercos.com/images/sistema-de-pedidos-com-ia.jpg",
  "name": "Sistema de pedidos com IA do Mercos",
  "description": "Captura de tela do WhatsApp para ser usada no recurso Pedidos com IA, mostrando que basta usar a conversa que chega pelo WhatsApp em diferentes formatos de mídia no sistema Mercos para criar um pedido no sistema com inteligência artificial. Ao lado é possível ver um exemplo de pedido com IA",
  "thumbnail": {
    "@type": "ImageObject",
    "contentUrl": "https://mercos.com/images/sistema-de-pedidos-com-ia.jpg"
  },
  "width": 530,
  "height": 600,
  "uploadDate": "2025-06-11",
  "license": "https://mercos.com/",
  "author": {
    "@type": "Organization",
    "name": "Mercos",
    "url": "https://www.mercos.com"
  },
  "copyrightHolder": {
    "@type": "Organization",
    "name": "Mercos"
  }
};

const videoJsonLd = {
  "@context": "https://schema.org",
  "@type": "VideoObject",
  "name": "Sistema de pedidos com IA Mercos: solução para vendas ágeis e sem erros",
  "description": "Seu negócio precisa de mais agilidade e menos erros na gestão de pedidos? Conheça o Sistema de Pedidos com IA do Mercos, a solução definitiva para automatizar suas vendas e aumentar a eficiência da sua equipe! O Sistema de Pedidos com IA interpreta automaticamente mensagens de texto, fotos, áudios e arquivos enviados pelos seus clientes (via WhatsApp, e-mail, Telegram e outras plataformas!) e transforma tudo em pedidos ou orçamentos dentro do sistema Mercos. Com o Sistema de Pedidos com IA, você garante: Vendas rápidas: economize tempo na criação de pedidos e acelere o processo; Sem erros: reduza drasticamente os erros manuais com a interpretação inteligente da IA; Mais produtividade: libere sua equipe para focar em negociação e fechamento de vendas; Integração total: funciona perfeitamente com o sistema de vendas e e-commerce B2B do Mercos; Ideal para indústrias, distribuidoras e representantes, o Sistema de Pedidos com IA suporta diversos formatos de arquivo (PDF, imagens, áudios e mais, até 20MB) e é intuitivo. Você pode revisar e corrigir qualquer sugestão da IA antes de finalizar o pedido. Assista ao vídeo e veja na prática como a IA é a solução inteligente para ter vendas rápidas e Sem erros, otimizando sua gestão de pedidos e impulsionando seu negócio! Saiba mais sobre o Sistema de Pedidos com IA e experimente grátis: #SistemaDePedidosComIA #Mercos #AutomaçãoDeVendas #GestãoDePedidos #InteligênciaArtificial #EcommerceB2B #AutomaçãoComIA",
  "uploadDate": "2025-06-10T13:30:00-03:00",
  "thumbnailUrl": "https://i9.ytimg.com/vi_webp/HNs0zWQ8tX0/mqdefault.webp?v=6849a374&sqp=CLzupsIG&rs=AOn4CLC_PWWtUCuCgeCxpXuBJ49S9X0bpQ",
  "contentUrl": "https://youtu.be/HNs0zWQ8tX0",
  "embedUrl": "https://www.youtube.com/embed/HNs0zWQ8tX0",
  "publisher": {
    "@type": "Organization",
    "name": "Mercos"
  }
};

class SistemaDePedidosComIAComponent extends React.Component {
  state = { isSmall: false };

  handleResize = e => this.setState({ isSmall: e.matches });

  componentDidMount() {
    this.mq = window.matchMedia('(max-width: 900px)');
    this.handleResize(this.mq);
    this.mq.addEventListener('change', this.handleResize);
  }

  componentWillUnmount() {
    if (this.mq) this.mq.removeEventListener('change', this.handleResize);
  }

  render() {
    const { isSmall } = this.state;
    return (
      <Fragment>
        <NewMenu />

        <div className="sistema-de-pedidos-com-ia-page">
          <section className="ia-hero container">
            <div className="ia-hero-main-content">
              <div className="ia-hero-title-container">
                <h1 className="ia-hero-title title">Sistema de Pedidos com IA</h1>
                <Picture className="ia-hero-sparkle" alt="Sparkle" src="/images/site/recursos/sparkle.svg" />
              </div>
              <h2 className="ia-hero-subtitle description">
                <b>Transforme mensagens do WhatsApp ou e-mails em pedidos em segundos</b>
                <br />
                Com o Sistema de Pedidos com IA, basta colar o texto do cliente,
                enviar um arquivo de foto, PDF, planilha ou áudio e pronto: o
                pedido é gerado automaticamente

              </h2>
            </div>

            <div className="glow-wrapper">
              <div className="ia-hero-video">
                <iframe
                  width="100%"
                  height="100%"
                  src="https://www.youtube.com/embed/HNs0zWQ8tX0"
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                  style={{ borderRadius: '20px', position: 'absolute', top: 0, left: 0 }}
                ></iframe>
              </div>
            </div>

            <HeroRatings />

            <div className="ia-hero-testimonial" id="ia-testimonial">
              <p className="ia-testimonial-text">
                “O sistema de <b>pedidos com IA da Mercos</b> tem nos ajudado muito aqui no escritório, especialmente na reta final do mês, quando vários pedidos se acumulam. Com ele, é possível importar os pedidos com muito mais agilidade.”
              </p>
              <div className="ia-testimonial-author">
                <Picture className="ia-author-avatar" alt="Joice Silva" src="/images/site/depoimentos/joice-silva.png" />
                <p className="ia-author-details">
                  <span className="ia-author-name">
                    Joice Silva
                    <br />
                  </span>
                  <span className="ia-author-title">
                    Gerente Comercial da empresa Musical Plus{" "}
                  </span>
                </p>
              </div>
            </div>
          </section>

          <section className="ia-upload-section container">
            <div className="ia-upload-content-wrapper">
              <div className="ia-upload-text-content">
                <div className="ia-upload-title-container">
                  <p className="ia-upload-title">Suba o arquivo<br /> e deixe o resto<br /> com a <span className="ia-upload-title-highlight">IA</span><Picture className="ia-upload-sparkle" alt="Sparkle" src="/images/site/recursos/sparkling-green.png" /></p>

                </div>
                <p className="ia-upload-description">
                  <span className="ia-upload-description-bold">
                    Chega de perder tempo lançando pedidos manualmente!
                    <br /> <br />
                  </span>
                  <Picture className="ia-upload-image mobile-only" alt=' Imagem mostrando o Sistema de Pedidos com IA dentro do Mercos. É possível ver a tela de pedidos do sistema, com foco na inserção de documento em PDF, áudio, vídeo, imagem ou planilha para a ferramenta ler o conteúdo e o transformar em um pedido após clicar em "Encontrar Produtos".' src="/images/site/recursos/pedidos-ia/adicionar-produtos-ia-mobile.png" />
                  <span className="ia-upload-description-regular">
                    Recebeu um pedido por WhatsApp ou e-mail e quer
                    lançá-lo no sistema Mercos de forma rápida e prática?
                    <br /> <br />
                  </span>
                  <span className="ia-upload-description-bold">Em segundos</span>
                  <span className="ia-upload-description-regular">
                    , o sistema de pedidos com IA interpreta as informações e gera a lista
                    de produtos para o pedido automaticamente para você. Basta conferir e
                    gerar o pedido!
                  </span>
                </p>
              </div>
              <div className="ia-upload-image-content">
                <Picture className="ia-upload-image desktop-only" alt=' Imagem mostrando o Sistema de Pedidos com IA dentro do Mercos. É possível ver a tela de pedidos do sistema, com foco na inserção de documento em PDF, áudio, vídeo, imagem ou planilha para a ferramenta ler o conteúdo e o transformar em um pedido após clicar em "Encontrar Produtos".' src="/images/site/recursos/pedidos-ia/adicionar-produtos-ia.png" />
              </div>
            </div>
          </section>

          <section className="ia-file-types-section container">
            <p className="ia-file-types-title">Cole textos, envie fotos, PDFs, áudios ou planilhas</p>
            <div className="ia-file-type-cards-container">
              <div className="ia-file-type-card">
                <Picture className="ia-file-type-icon" alt="Planilha Icon" src="/images/site/recursos/icon-planilha.png" />
                <p className="ia-file-type-name">Planilha</p>
                <p className="ia-file-type-description">Suba pedidos do Excel, .xlsx ou .csv</p>
              </div>
              <div className="ia-file-type-card">
                <Picture className="ia-file-type-icon" alt="Audio Icon" src="/images/site/recursos/icon-audio.png" />
                <p className="ia-file-type-name">Áudio</p>
                <p className="ia-file-type-description">Envie arquivos<br />ou dite o pedido</p>
              </div>
              <div className="ia-file-type-card">
                <Picture className="ia-file-type-icon" alt="PDF Icon" src="/images/site/recursos/icon-pdf.png" />
                <p className="ia-file-type-name">PDF</p>
                <p className="ia-file-type-description">Salve e envie arquivos<br />sem dificuldades</p>
              </div>
              <div className="ia-file-type-card">
                <div className="ia-file-type-icon-wrapper">
                  <Picture className="ia-file-type-icon image-icon" alt="Imagem Icon" src="/images/site/recursos/icon-imagem.png" />
                </div>
                <p className="ia-file-type-name">Imagem</p>
                <p className="ia-file-type-description">Fotos viram pedidos<br />rapidamente</p>
              </div>
            </div>
          </section>

          <section className="ia-reduce-errors-section container">
            <div className="ia-reduce-errors-content-wrapper">
              <div className="ia-reduce-errors-image-content">
                <Picture className="ia-reduce-errors-image desktop-only" alt="Interface do sistema de pedidos com IA" src="/images/sistema-de-pedidos-com-ia.jpg" />
              </div>
              <div className="ia-reduce-errors-text-content">
                <h3 className="ia-reduce-errors-title">Reduza erros com o sistema de pedidos com IA</h3>
                <Picture className="ia-reduce-errors-image mobile-only" alt="Interface do sistema de pedidos com IA" src="/images/site/recursos/pedidos-ia/reduza-erros-mobile.png" />
                <p className="ia-reduce-errors-description">
                  A IA interpreta os pedidos automaticamente e ainda permite revisão
                  antes de finalizar, o que evita falhas humanas e pedidos errados.
                  Você reduz o tempo gasto com tarefas operacionais e ganha
                  produtividade em vendas, atendimento e negociação.
                </p>
                <hr className="ia-reduce-errors-divider" />
                <ul className="ia-features-list">
                  <li className="ia-feature-item">
                    <div className="ia-feature-icon">
                      <Picture alt="Checkmark" src="/images/site/recursos/checkmark.svg" />
                    </div>
                    <p className="ia-feature-text">
                      Recurso disponível para todos os planos e de forma ilimitada nos
                      planos Ouro e Corporativo
                    </p>
                  </li>
                  <li className="ia-feature-item">
                    <div className="ia-feature-icon">
                      <Picture alt="Checkmark" src="/images/site/recursos/checkmark.svg" />
                    </div>
                    <p className="ia-feature-text">
                      Use o botão “Ditar texto” para gravar um áudio com os produtos
                      que devem ser adicionados ao orçamento
                    </p>
                  </li>
                  <li className="ia-feature-item">
                    <div className="ia-feature-icon">
                      <Picture alt="Checkmark" src="/images/site/recursos/checkmark.svg" />
                    </div>
                    <p className="ia-feature-text">
                      Integrado ao e-commerce B2B: seus pedidos viram um carrinho em
                      segundos
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </section>

          <TwoColumnAccordionWithImage
            isAIPage
            mainTitleRegular="Eliminamos a digitação manual "
            mainTitleBold="para você focar no que realmente importa: vender"
            titleGraphicSrc="/images/site/recursos/underline.png"
            titleGraphicAlt="Elemento gráfico decorativo"
            features={[
              {
                id: 'menos-erros',
                iconSrc: '/images/site/recursos/clipboard-check.svg',
                iconAlt: 'Ícone menos erros',
                title: 'Menos erros nos pedidos',
                description: 'O sistema de pedidos com IA interpreta o pedido automaticamente, você revisa os produtos, finaliza a venda e pode focar em visitas e reuniões mais qualificadas, novos clientes, resultados e métricas comerciais.',
                arrowSrc: '/images/site/recursos/arrow-down.svg',
                arrowAlt: 'Expandir/recolher',
                imageSrc: '/images/site/recursos/menos-erros.jpg',
                imageAlt: 'Visualização de menos erros com IA'
              },
              {
                id: 'flexibilidade',
                iconSrc: '/images/site/recursos/process.svg',
                iconAlt: 'Ícone flexibilidade',
                title: 'Flexibilidade para vários formatos',
                description: 'O recurso Pedidos com IA aceita textos, fotos, áudios, PDFs e planilhas — assim, você pode enviar pedidos do jeito que for mais fácil, sem precisar reformatar nada.',
                arrowSrc: '/images/site/recursos/arrow-down.svg',
                arrowAlt: 'Expandir/recolher',
                imageSrc: '/images/site/recursos/flexibilidade.png',
                imageAlt: 'Diversos formatos suportados pela IA'
              },
              {
                id: 'facilidade-equipes',
                iconSrc: '/images/site/recursos/people-plus.svg',
                iconAlt: 'Ícone facilidade para equipes',
                title: 'Facilidade para equipes externas e internas',
                description: 'Com a IA vendedores externos e televendas criam pedidos rapidamente pelo computador, ditando a conversa ou enviando arquivos. Isso aumenta a produtividade e o alcance da equipe.',
                arrowSrc: '/images/site/recursos/arrow-down.svg',
                arrowAlt: 'Expandir/recolher',
                imageSrc: '/images/site/recursos/facilidade.png',
                imageAlt: 'Equipes utilizando IA para pedidos'
              }
            ]}
            mainImageSrc="/images/site/recursos/menos-erros.jpg"
            mainImageAlt="Persona focada em vender"
          />

          <section className="ia-testimonial-section container">
            <TestimonialVideoCards isAI isAIPage
              title={
                <Fragment><b>Confira a opinião de quem já usa</b> o sistema de pedidos com IA na Mercos</Fragment>
              }
            />
          </section>


          <TrustedByCompanies isAIPage />

          <section className="cta-test-section container">
            <PromoBannerCTA
              isAIPage
              headline={<Fragment>Teste o Mercos e conheça o <br />sistema de pedidos com IA</Fragment>}
            />
          </section>

          <section className="faq-section container">
            <GenericFAQ
              isAIPage
              title={<Fragment>Perguntas frequentes sobre o sistema de pedidos com IA</Fragment>}
              defaultOpenIndex={0}
              faqItems={newFaqItems}
            />
          </section>

        </div>

        <NewFooter />


      </Fragment>
    );
  }
}

export default withRouteData(({ headData }) => (
  <Fragment>
    <Head>
      <title>{headData && headData.pageTitle ? headData.pageTitle : 'Sistema de Pedidos com IA - Mercos'}</title>
      <meta name="description" content={headData && headData.pageDescription ? headData.pageDescription : "Transforme mensagens do WhatsApp ou e-mails em pedidos em segundos com o Sistema de Pedidos com IA da Mercos."} />
      {headData && headData.ogUrl && <link rel="canonical" href={headData.ogUrl} />}
      {headData && headData.pageTitle && <meta property="og:title" content={headData.pageTitle} />}
      {headData && headData.pageTitle && <meta name="twitter:title" content={headData.pageTitle} />}
      {headData && headData.pageDescription && <meta property="og:description" content={headData.pageDescription} />}
      {headData && headData.pageDescription && <meta name="twitter:description" content={headData.pageDescription} />}
      {headData && headData.ogImage && <meta property="og:image" content={headData.ogImage} />}
      {headData && headData.ogImage && <meta name="twitter:image" content={headData.ogImage} />}
      {headData && headData.ogUrl && <meta property="og:url" content={headData.ogUrl} />}
      <script type="application/ld+json">
        {JSON.stringify(faqJsonLd)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(imageJsonLd)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(videoJsonLd)}
      </script>
    </Head>
    <SistemaDePedidosComIAComponent />
  </Fragment>
));


// WEBPACK FOOTER //
// /usr/src/site-blog/src/containers/site/recursos/SistemaDePedidosComIA.jsx